var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isProfileSelected)?_c('div',[(_vm.activeRole === 'therapist')?_c('dashboard-therapist'):_vm._e(),(_vm.activeRole === 'patient')?_c('dashboard-patient'):_vm._e()],1):_vm._e(),(!_vm.isProfileSelected)?_c('select-profile'):_vm._e(),(!_vm.isAcceptedTerms)?_c('dialog-accept-terms'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }